import Vue from "vue";
import VueGtag from "vue-gtag";
import router from '../router'

Vue.use(VueGtag, {
    config: { id: "G-3HP22JH1Q7" },
    bootstrap: false
}, router);